import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PrivateHeader from "../../components/private/PrivateHeader";
import BackLink from "../../components/BackLink";
import {
    usePrivateProjectAccess,
    usePrivateProject,
} from "./PrivateProjectDetail/usePrivateProject";
import LoadingScreen from "./PrivateProjectDetail/LoadingScreen";
import Hero from "./PrivateProjectDetail/Hero";
import Overview from "./PrivateProjectDetail/Overview";
import ExtendedGallery from "./PrivateProjectDetail/ExtendedGallery";
import SpecsSection from "./PrivateProjectDetail/SpecsSection";
import SchematicSection from "./PrivateProjectDetail/SchematicSection";
import Narrative from "./PrivateProjectDetail/Narrative";
import NextProject from "./PrivateProjectDetail/NextProject";
import DetailFooter from "./PrivateProjectDetail/DetailFooter";

export default function PrivateProjectDetail() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { authState, email, onSignOut } = usePrivateProjectAccess(navigate);
    const { project, nextProject, error } = usePrivateProject(
        slug,
        authState,
        navigate,
    );

    if (authState !== "ok" || !project) {
        return <LoadingScreen error={error} />;
    }

    const { base, extended } = project;

    return (
        <div
            className="min-h-screen bg-[#0B0B0C] text-[#F3EFE7]"
            data-testid={`private-detail-${base.name.slice(0, 12)}`}
        >
            <Helmet>
                <title>{`${base.name} · Private — ACT`}</title>
                <meta name="robots" content="noindex,nofollow" />
            </Helmet>

            <PrivateHeader email={email} onSignOut={onSignOut} />

            <div className="max-w-[1280px] mx-auto px-6 md:px-10 pt-6 md:pt-8">
                <BackLink to="/private" label="Back to portfolio" />
            </div>

            <Hero base={base} />
            <Overview base={base} />
            <ExtendedGallery base={base} gallery={extended.extended_gallery} />
            <SpecsSection specs={extended.system_specs} />
            <SchematicSection schematic={extended.schematic} />
            <Narrative paragraphs={extended.additional_narrative} />
            <NextProject nextProject={nextProject} />
            <DetailFooter onSignOut={onSignOut} />
        </div>
    );
}
